import React from 'react';
import { Leaf } from 'lucide-react';
export function BotanicalDivider() {
  return <div className="flex items-center justify-center py-8 opacity-40" data-id="element-191">
      <div className="h-px w-16 bg-[#4A5D3A]" data-id="element-192"></div>
      <Leaf className="mx-4 text-[#4A5D3A]" size={20} strokeWidth={1.5} data-id="element-193" />
      <div className="h-px w-16 bg-[#4A5D3A]" data-id="element-194"></div>
    </div>;
}